import { useCallback } from "react";
import { useMsal } from "@azure/msal-react";
import { apiRequest } from "@src/authConfig";

export const useApiService = () => {
    const { instance } = useMsal();

    const getAccessToken = useCallback(async (): Promise<string> => {
        const accounts = instance.getAllAccounts();

        if (accounts.length === 0) {
            throw new Error("No user account found. Please log in.");
        }

        const request = {
            ...apiRequest,
            account: accounts[0],
        };

        try {
            const response = await instance.acquireTokenSilent(request);
            return response.accessToken;
        } catch (error) {
            const response = await instance.acquireTokenPopup(request);
            return response.accessToken;
        }
    }, [instance]);

    const get = useCallback(async (url: string): Promise<Response> => {
        const token = await getAccessToken();

        return fetch(url, {
            method: "GET",
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });
    }, [getAccessToken]);

    const post = useCallback(async (url: string, body: any): Promise<Response> => {
        const token = await getAccessToken();

        return fetch(url, {
            method: "POST",
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json",
            },
            body: JSON.stringify(body),
        });
    }, [getAccessToken]);

    return { get, post };
};
